import React, { memo } from 'react';
import { Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import WarningIcon from '@mui/icons-material/Warning';
import { useIntl } from 'react-intl';
import { COMMENT_MAX_CHAR_LIMIT } from 'modules/notes/common/noteSchema';
import { FormCheckbox } from '../FormCheckbox';
import { SmartDiaryEntry } from '../type';

type SmartListItemIconProps = {
  smartEntry: SmartDiaryEntry;
};

const useStyles = makeStyles((theme) => ({
  warning: {
    color: theme.palette.error.main,
    margin: theme.spacing(1.125)
  }
}));

export const SmartListItemIcon: React.FC<SmartListItemIconProps> = memo(
  ({ smartEntry }: SmartListItemIconProps) => {
    const classes = useStyles();
    const { formatMessage } = useIntl();
    const message = formatMessage(
      { id: 'smartDiary.commentErrorMessage' },
      {
        maxLimit: COMMENT_MAX_CHAR_LIMIT
      }
    );
    return (
      <>
        {smartEntry.comment?.error?.description ? (
          <Tooltip title={message}>
            <WarningIcon
              data-testid={`smart-entry-item_error_${smartEntry.id}`}
              className={classes.warning}
            />
          </Tooltip>
        ) : (
          <FormCheckbox
            name={smartEntry.id}
            disabled={!smartEntry.canBeSynced}
            smartEntry={smartEntry}
          />
        )}
      </>
    );
  }
);

SmartListItemIcon.displayName = 'SmartListItemIcon';
